import { useNavigate } from 'react-router-dom';
import { firebaseAuth, firebaseGetAuth } from '../firebase/config';

export const Home: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
          await firebaseAuth.signOut(firebaseGetAuth);
          
          navigate('/login');
        } catch (error) {
          console.error('Error al cerrar sesión:', error);
        }
      };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <h1 className="text-4xl font-bold">Welcome to Dashboard</h1>
            
            <button 
              onClick={handleLogout}
              className="bg-red-500 text-white py-2 px-4 rounded mt-5"
            >
              Log Out
            </button>
        </div>
    );
};